// utils/date.js
import dayjs from '@/utils/dayjs'
import { i18n } from '@/services/i18n'

/**
 * Format a date string assuming it's in UTC (e.g., for backend-generated timestamps like created_at)
 */
export const timeAgo = (dateString) => {
  const now = dayjs();
  const date = dayjs.utc(dateString);

  if (!date.isValid()) return '';

  const daysDiff = now.diff(date, 'day');

  if (daysDiff < 7) {
    return date.fromNow();
  }

  const formatStr = i18n.global.t('date_format');
  return date.format(formatStr);
};